<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.monthMaterialCost") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/prd/monthMaterialCost"><span>{{$t('tlt.monthMaterialCost')}}</span></router-link></li>
                </ul>
            </div>
            <!-- <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('monthMaterialCost')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>                       
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div> -->
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">                                
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.locName") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="plantFilter"/>
                                </div> 
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.startMonth") }} :
                                    </label>
                                    <mmf-monthpicker      v-model="startMonthFilter"></mmf-monthpicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.endMonth") }} :
                                    </label>
                                    <mmf-monthpicker      v-model="endMonthFilter"></mmf-monthpicker>
                                </div> 
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.materialName") }} :
                                    </label>
                                    <input class="form-control" type="text" v-model="materialFilter"/>
                                </div> 
                                <div class="col-lg-4 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('monthMaterialCost')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('monthMaterialCost')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="monthMaterialCostResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="monthMaterialCost" inline-actions-disabled singleChoice>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <echart v-if="option.dataArray.length !=0" :optionSet="option" ></echart> -->
        </section>        
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/prd/productionReport/monthReport/MonthMaterialCost";
import MmfTable from "@/components/MmfTable";
import MmfMonthpicker from '@/components/MmfMonthpicker';
import echart from '@/components/MmfEcharts/MmfEcharts.vue'

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'monthMaterialCost/getField',
    mutationType: 'monthMaterialCost/updateField',
});

export default {
  name: "monthMaterialCostList",
  data () {
    return {
    //   checkedItems: []
        yNameMap: {
            wetWeight:'湿重',
            dryWeight:'干重'
        },
        xNameMap:{
            month:'month'
        }
    }
  },
  components: { MmfTable, MmfMonthpicker, echart },
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            rows: state => state.monthMaterialCost.rows,            
            checkedItems: state => state.monthMaterialCost.checkedItems,
            showNoResultAlert: state => state.base.showNoResultAlert,
            tableColumns: gridFields
        }),
    option(state){
        let nameMap = Object.assign({}, this.xNameMap, this.yNameMap);
        return {
            dataArray:this.rows.map(row => {
                return Object.keys(nameMap).reduce((prev,key)=>{
                    prev[nameMap[key]] = row[key]
                    return prev
                },{})
            }),
            xName:Object.keys(this.xNameMap).map(name=>this.xNameMap[name]),
            xIndex:'0',
            yName:Object.keys(this.yNameMap).map(name=>this.yNameMap[name]),
            chartType:'verticalLine',
            title:'Material Cost'
        }
    },
  },
  methods: {
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  },
  mounted(){
  }
};
</script>
